import React from 'react';
import { PolicyModal } from './PolicyModal';
type TermsOfServiceModalProps = {
  onClose: () => void;
};
export const TermsOfServiceModal = ({
  onClose
}: TermsOfServiceModalProps) => {
  return <PolicyModal title="Terms of Service" onClose={onClose} data-id="element-706">
      <div className="space-y-6 text-[#6B4B3E]" data-id="element-707">
        <p className="text-sm text-[#6B4B3E]/75" data-id="element-708">Last Updated: May 18, 2025</p>
        <p data-id="element-709">
          Welcome to Story Bunny AI (the "Website"), an AI-powered storytelling
          experience for children and families, operated by Story Bunny AI LLC
          ("we," "us," or "our"). Please read these Terms of Service ("Terms")
          carefully before using our Website.
        </p>
        <p data-id="element-710">
          By accessing or using our Website, you agree to be bound by these
          Terms. If you do not agree to these Terms, please do not use the
          Website.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-711">1. Eligibility</h3>
        <p data-id="element-712">
          The Website is designed for children with the supervision or
          involvement of a parent or guardian. You must be at least 13 years old
          to create an account. If you are under 13, a parent or legal guardian
          must provide consent and manage the account on your behalf.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-713">2. Accounts</h3>
        <p data-id="element-714">
          Some features of Story Bunny AI require account creation. When
          registering, you must provide accurate and complete information. You
          are responsible for maintaining the confidentiality of your login
          credentials and for all activities under your account. If you suspect
          unauthorized use, you agree to notify us immediately at
          support@storybunny.ai.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-715">3. Subscription Policy</h3>
        <p data-id="element-716">Story Bunny AI offers subscription-based services:</p>
        <ul className="list-disc pl-6 space-y-2" data-id="element-717">
          <li data-id="element-718">
            Monthly Subscriptions renew automatically each month unless canceled
            before the renewal date.
          </li>
          <li data-id="element-719">
            Yearly Subscriptions renew annually and offer discounted pricing.
          </li>
        </ul>
        <p className="mt-4" data-id="element-720">
          Subscriptions can be managed or canceled through your account
          settings. Please note that we do not offer refunds for unused time if
          you cancel before the end of a billing cycle.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-721">4. Intellectual Property</h3>
        <p data-id="element-722">
          All content on the Website—including stories, characters, artwork,
          design, code, and branding—is the intellectual property of Story Bunny
          AI LLC or its content partners. You may not copy, modify, reproduce,
          or distribute any part of our content without written permission.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-723">5. User Conduct</h3>
        <p data-id="element-724">You agree not to use the Website in ways that:</p>
        <ul className="list-disc pl-6 space-y-2" data-id="element-725">
          <li data-id="element-726">Violate any law or regulation;</li>
          <li data-id="element-727">Infringe on the rights of others;</li>
          <li data-id="element-728">Upload viruses or malicious code;</li>
          <li data-id="element-729">Attempt to access systems or data without authorization;</li>
          <li data-id="element-730">Disrupt the experience for other users.</li>
        </ul>
        <p className="mt-4" data-id="element-731">
          We reserve the right to suspend or terminate accounts for violations
          of these Terms.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-732">
          6. Disclaimers and Limitation of Liability
        </h3>
        <p data-id="element-733">
          The Website and all content are provided "as is" and "as available."
          We do not guarantee the Website will be error-free or uninterrupted.
          We disclaim all warranties, including implied warranties of
          merchantability or fitness for a particular purpose.
        </p>
        <p className="mt-4" data-id="element-734">
          To the fullest extent allowed by law, Story Bunny AI LLC is not liable
          for any damages—including indirect, incidental, or consequential
          damages—arising from your use of the Website.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-735">7. Termination</h3>
        <p data-id="element-736">
          We may suspend or terminate your access to the Website at any time and
          for any reason, including violation of these Terms. You may also
          delete your account at any time by contacting support@storybunny.ai.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-737">8. Changes to These Terms</h3>
        <p data-id="element-738">
          We may update these Terms at any time. Changes will be posted on this
          page with an updated "Last Updated" date. By continuing to use the
          Website after changes are made, you agree to be bound by the revised
          Terms.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-739">9. Governing Law</h3>
        <p data-id="element-740">
          These Terms shall be governed by the laws of the State of New York,
          without regard to conflict of law principles.
        </p>
        <h3 className="text-lg font-bold mt-8" data-id="element-741"></h3>
        <p data-id="element-742"></p>
        <p className="mt-4" data-id="element-743">
          Story Bunny AI LLC
          <br data-id="element-744" />
        
          
          🌐 www.storybunny.ai
        </p>
      </div>
    </PolicyModal>;
};